export default __webpack_public_path__ + "static/media/ti.165be90a.jpg";